"use strict";
var appn;
(function (appn) {
    appn.verifyHeader = appn.verifyHeader;
    appn.requestUser = appn.requestUser;
    appn.requestProvider = appn.requestProvider;
    appn.urls = appn.urls;
    appn.strings = appn.strings;
    appn.emptyGuid = appn.emptyGuid;
    appn.emptyString = '';
    appn.isDebug = appn.isDebug;
    appn.isTestSuiteRequest = appn.isTestSuiteRequest;
    appn.isDefaultRequest = appn.isDefaultRequest;
    appn.hasFormSubmitAlreadyHappened = false;
    appn._MAXFILESIZE = 78643200;
    $.validator.addMethod('requiredif', function (value, element, params) {
        if (appn.utils.hasValue(value))
            return true;
        const parentRules = [];
        const child = $(element);
        let parentSelector = child.attr('data-val-parent');
        if (!appn.utils.hasValue(parentSelector))
            parentSelector = '.card-body';
        params.requiredpropertyname.split(',').forEach((o, i, a) => {
            const requiredParent = child.closest(parentSelector).find(`[id$="${o.trim()}"]`);
            const requiredValue = params.requiredvalue.split(',')[i];
            const rule = {
                parent: requiredParent,
                value: requiredValue
            };
            parentRules.push(rule);
        });
        let hasError = false;
        parentRules.forEach((o, i, a) => {
            const currentParentValue = o.parent.val();
            if (appn.utils.hasValue(o.value)) {
                if (o.value.localeCompare(currentParentValue) === 0)
                    hasError = true;
            }
            else {
                if (!appn.utils.hasValue(currentParentValue))
                    hasError = true;
            }
        });
        return hasError ? false : true;
    });
    $.validator.unobtrusive.adapters.add('requiredif', ['requiredpropertyname', 'requiredvalue'], function (options) {
        const params = {
            requiredpropertyname: options.params.requiredpropertyname,
            requiredvalue: options.params.requiredvalue
        };
        options.rules['requiredif'] = params;
        options.messages['requiredif'] = options.message;
    });
    appn.pageDropUtc = '';
    appn.timeZones = [];
    $(function () {
        appn.log.init();
        restructureNav();
        appn.pubSub.publishDomReady();
        $('#blobDestroy').remove();
        if (isSkipInitialization()) {
            appn.pubSub.publishAppnReady();
            return;
        }
        appn.localStorage.autoClearLs();
        addEvents();
        appn.ui.initDateAndTimePickers();
        initDualListBox();
        appn.iframe.init();
        appn.shortcuts.init();
        appn.toast.init();
        initTimeAgo();
        setValidationErrorStyle();
        initPlaceholders();
        appn.tooltip.init();
        appn.popover.init();
        appn.services.startPingTimer();
        appn.ui.initOpenOnClick();
        appn.launchInlineManual.init();
        addJqueryExtensions();
        appn.ui.abbreviateNumbers();
        warnMobileUsers();
        appn.modalStandard.init();
        appn.modalStandard.initFullscreenToggle();
        appn.select.init();
        appn.fileUploadUtils.init();
        appn.ui.initCardSummaries();
        appn.ui.initTriStateCheckboxes();
        const mainForm = appn.ui.getMainContentForm();
        if (appn.utils.hasValue(mainForm) && appn.utils.hasValue(mainForm.data('validator')))
            mainForm.data('validator').settings.ignore = ':hidden:not(.validate-always)';
        $('input:submit').button();
        $('#showModalOnLoad').modal('show');
        appn.notifications.updateNotificationTotal(true);
        appn.saveMeState.init();
        appn.burgerMenu.init();
        appn.posthog.init();
        appn.pubSub.publishAppnReady();
        appn.intersectionObserver.init();
        autoFocusFirstTextInput();
        onContentScroll();
        throwErrorIfDuplicateCheckboxIds();
        checkForExpiredPassword();
    });
    function checkForExpiredPassword() {
        if (!appn.requestUser.isPExpired)
            return;
        if (appn.location.urlContains('/account/settings'))
            return;
        appn.dialog.alert({
            modalColor: 'modal-warning',
            title: T('Your password has expired'),
            message: `<span class="lead text-muted">${T(`You must <a href='{0}'>change your password</a> now.`, appn.urls.account.settings)}</span>`,
            buttons: {
                ok: {
                    label: '<span>' + T('OK') + '</span>',
                    className: 'btn-success'
                }
            },
            autoHeaderIcon: false
        });
    }
    function throwErrorIfDuplicateCheckboxIds() {
        if (!appn.isDebug && !appn.isTestSuiteRequest)
            return;
        let ids = "|";
        $('.appn-checkbox input').each(function () {
            let id = $(this).prop('id');
            if (ids && id) {
                id = `|${id}|`;
                if (ids.contains(id)) {
                    const msg = `${T('Eish... Multiple duplicate Checkbox Ids found on page:')} ${id}`;
                    alert(msg);
                    throw msg;
                }
                ids += id;
            }
        });
    }
    function onContentScroll() {
        $(document).scroll(function () {
            const currentPosition = $(document).scrollTop();
            const body = $('body');
            if (currentPosition > 0) {
                body.removeClass('show-header-shadow').addClass('show-header-shadow');
                return;
            }
            body.removeClass('show-header-shadow');
        });
    }
    function autoFocusFirstTextInput() {
        const firstTextInput = $('section.content form:first input[type="text"]:first');
        if (!appn.utils.hasValue(firstTextInput) || firstTextInput.val().length > 0)
            return;
        firstTextInput.focus();
    }
    function restructureNav() {
        $('.main-sidebar').before($('.main-header.navbar'));
        $('.main-header.navbar').prepend($('#clientsTab'));
        const leftLinks = $('.main-header.navbar .navbar-nav-left a');
        if (leftLinks.length)
            leftLinks.each(function (index, element) {
                $(element)
                    .addClass('nav-link')
                    .removeClass('btn').removeClass('btn-link')
                    .wrap('<li class="nav-item d-sm-inline-block"></li>');
            });
        else {
            $('.main-header.navbar .navbar-nav-left').hide();
            $('.main-header.navbar').addClass('navbar-no-left-links');
        }
        $('.main-header.navbar .navbar-nav-right button').each(function (index, element) {
            const attrName = $(element).attr('name');
            const attrValue = $(element).attr('value');
            const mainForm = appn.ui.getMainContentForm();
            const hiddenToAppendToForm = `<input name="${(attrName ? attrName : appn.emptyString)}" value="${(attrValue ? attrValue : appn.emptyString)}" type="hidden">`;
            $(element).on('click', function () {
                if (!attrName)
                    return;
                const ignoreNavRestructuredSubmit = $(this).data('ignore-nav-restructured-submit');
                if (ignoreNavRestructuredSubmit)
                    return;
                mainForm.find(`input[type="hidden"][name="${attrName}"][value="${attrValue}"]`).remove();
                mainForm.prepend(hiddenToAppendToForm);
                if ($(this).val().containsIgnoreCase('delete'))
                    return;
                if ($(this).val().containsIgnoreCase('remove'))
                    return;
                if ($(this).val().containsIgnoreCase('trash'))
                    return;
                if ($(this).val().containsIgnoreCase('publish') && !$('body').hasClass('appn-view-docdefinitions-edit'))
                    return;
                mainForm.submit();
            });
        });
    }
    function isSkipInitialization() {
        return appn.location.urlContains('/apiexplorer');
    }
    function warnMobileUsers() {
        if (window.location.pathname.indexOf('Introduction') !== -1)
            return;
        if (!isMobile() || appn.localStorage.getItem('mobile-user-warned'))
            return;
        alert(T('This site is optimized for modern Desktop Browsers (Chrome, Firefox, and Edge). Some features are not supported on mobile devices. Please load this site in a Modern Desktop Browser for the best experience.'));
        appn.localStorage.setItem('mobile-user-warned', true);
    }
    function isMobile() {
        let check = false;
        (function (a) {
            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
                check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }
    appn.isMobile = isMobile;
    function getPlatform() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent))
            return 'android';
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
            return 'ios';
        return 'windows';
    }
    appn.getPlatform = getPlatform;
    function initTimeAgo() {
        if (appn.translator.culture === 'de') {
            jQuery.timeago.settings.strings = {
                prefixAgo: "vor",
                prefixFromNow: "in",
                inPast: "jetzt gleich",
                seconds: "wenigen Sekunden",
                minute: "etwa einer Minute",
                minutes: "%d Minuten",
                hour: "etwa einer Stunde",
                hours: "%d Stunden",
                day: "etwa einem Tag",
                days: "%d Tagen",
                month: "etwa einem Monat",
                months: "%d Monaten",
                year: "etwa einem Jahr",
                years: "%d Jahren"
            };
        }
        else if (appn.translator.culture === 'es') {
            jQuery.timeago.settings.strings = {
                prefixAgo: "hace",
                prefixFromNow: "dentro de",
                seconds: "menos de un minuto",
                minute: "un minuto",
                minutes: "unos %d minutos",
                hour: "una hora",
                hours: "%d horas",
                day: "un día",
                days: "%d días",
                month: "un mes",
                months: "%d meses",
                year: "un año",
                years: "%d años"
            };
        }
        else if (appn.translator.culture === 'fr') {
            jQuery.timeago.settings.strings = {
                prefixAgo: "il y a",
                prefixFromNow: "d'ici",
                seconds: "moins d'une minute",
                minute: "une minute",
                minutes: "%d minutes",
                hour: "une heure",
                hours: "%d heures",
                day: "un jour",
                days: "%d jours",
                month: "un mois",
                months: "%d mois",
                year: "un an",
                years: "%d ans"
            };
        }
        else if (appn.translator.culture === 'it') {
            jQuery.timeago.settings.strings = {
                prefixFromNow: "fra",
                suffixAgo: "fa",
                seconds: "meno di un minuto",
                minute: "circa un minuto",
                minutes: "%d minuti",
                hour: "circa un'ora",
                hours: "circa %d ore",
                day: "un giorno",
                days: "%d giorni",
                month: "circa un mese",
                months: "%d mesi",
                year: "circa un anno",
                years: "%d anni"
            };
        }
        else if (appn.translator.culture === 'nl') {
            jQuery.timeago.settings.strings = {
                prefixFromNow: "over",
                suffixAgo: "geleden",
                seconds: "minder dan een minuut",
                minute: "ongeveer een minuut",
                minutes: "%d minuten",
                hour: "ongeveer een uur",
                hours: "ongeveer %d uur",
                day: "een dag",
                days: "%d dagen",
                month: "ongeveer een maand",
                months: "%d maanden",
                year: "ongeveer een jaar",
                years: "%d jaar"
            };
        }
        else if (appn.translator.culture === 'pt') {
            jQuery.timeago.settings.strings = {
                prefixAgo: "há",
                prefixFromNow: "em",
                seconds: "alguns segundos",
                minute: "um minuto",
                minutes: "%d minutos",
                hour: "uma hora",
                hours: "%d horas",
                day: "um dia",
                days: "%d dias",
                month: "um mês",
                months: "%d meses",
                year: "um ano",
                years: "%d anos"
            };
        }
        else {
            jQuery.timeago.settings.strings = {
                suffixAgo: "ago",
                suffixFromNow: "from now",
                seconds: "under a minute",
                minute: "a minute",
                minutes: "%d minutes",
                hour: "an hour",
                hours: "%d hours",
                day: "a day",
                days: "%d days",
                month: "a month",
                months: "%d months",
                year: "a year",
                years: "%d years"
            };
        }
        $('abbr.timeago').timeago();
    }
    function setValidationErrorStyle() {
        $('input[type=text],select,textarea').each(function () {
            const req = $(this).attr('data-val-required');
            if (req) {
                if ($(this).val() === appn.emptyString)
                    $(this).addClass('input-validation-error');
                $(this).change(function () {
                    if ($(this).val() === appn.emptyString)
                        $(this).addClass('input-validation-error');
                    else
                        $(this).removeClass('input-validation-error');
                });
            }
        });
    }
    function initPlaceholders() {
        $('input, textarea').placeholder();
    }
    function initDualListBox() {
        $('.multiselect').bootstrapDualListbox({
            selectedListLabel: T('Selected'),
            nonSelectedListLabel: T('Not Selected')
        });
    }
    function addEvents() {
        $('button[name="submitType"], nav button[name="submitType"]').filter(function () {
            if (this.value.containsIgnoreCase('delete'))
                return true;
            if (this.value.containsIgnoreCase('remove'))
                return true;
            return false;
        }).off().on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const preventAutoModalHide = $(this).data('preventautomodalhide');
            if (!preventAutoModalHide)
                appn.dialog.hide();
            const submitType = this.value;
            const btnsForm = $(this).closest('form');
            const mainForm = appn.utils.hasValue(btnsForm) ? btnsForm : appn.ui.getMainContentForm();
            const deleteMessageOverride = $(this).data('deletemessage');
            const ignoreValidation = $(this).data('deleteignorevalidation');
            let deleteDetailsData = $(this).attr('data-deletedetail');
            deleteDetailsData = deleteDetailsData && deleteDetailsData.IsJSON() ? JSON.parse(deleteDetailsData) : deleteDetailsData;
            const deleteDetailOverride = deleteDetailsData && deleteDetailsData.trim().length > 0 ? deleteDetailsData : undefined;
            appn.trash.deleteConfirm(mainForm, submitType, ignoreValidation, deleteDetailOverride, deleteMessageOverride || deleteMessageOverride === appn.emptyString ? deleteMessageOverride : undefined);
            appn.popover.init();
        });
        $('button[name="submitType"]').filter(function () {
            if (this.value.containsIgnoreCase('trash'))
                return true;
            return false;
        }).off().on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const preventAutoModalHide = $(this).data('preventautomodalhide');
            if (!preventAutoModalHide)
                appn.dialog.hide();
            const submitType = this.value;
            const btnsForm = $(this).closest('form');
            const mainForm = appn.utils.hasValue(btnsForm) ? btnsForm : appn.ui.getMainContentForm();
            const trashMessageOverride = $(this).data('trashmessage');
            const trashDetailsData = $(this).attr('data-trashdetail');
            const trashDetailOverride = trashDetailsData && trashDetailsData.trim().length > 0 ? JSON.parse(trashDetailsData) : undefined;
            appn.trash.trashConfirm(mainForm, submitType, trashDetailOverride, trashMessageOverride && trashMessageOverride.trim().length > 0 ? trashMessageOverride : undefined);
        });
        $('.sidebar-toggle').off().on('click', function (event) {
            event.preventDefault();
            if (!$(this).parents('.main-sidebar').hasClass('sidebar-got-closed') && !$('body').hasClass('sidebar-collapse')) {
                $('.main-sidebar').addClass('sidebar-got-closed');
                $('.brand-link').mouseleave(function () {
                    $('.main-sidebar').removeClass('sidebar-got-closed');
                });
            }
            else
                $('.sidebar-got-closed .main-sidebar').removeClass('sidebar-got-closed');
            if ($('body').hasClass('sidebar-collapse'))
                appn.localStorage.setItem('expand-sidebar', true);
            else
                appn.localStorage.setItem('expand-sidebar', false);
            appn.dataTable.redrawOnResize(300);
            if (appn.notifications.notificationPoll > 60000)
                setTimeout(function () {
                    window.clearTimeout(appn.notifications.notificationTimer);
                    appn.notifications.updateNotificationTotal();
                }, 1000);
            appn.pubSub.publish(appn.pubSub.WINDOW_RESIZED);
        });
        $('form').submit(function (e) {
            if (!$(this).valid()) {
            }
            else if (!$(this).hasClass('no-loading-screen') &&
                !$('body#appn-iframe-modal-body').length &&
                !$('#e-modal').is(':visible')) {
                if (appn.hasFormSubmitAlreadyHappened) {
                    const msg = T('Eish... More than one form submit detected!');
                    if (appn.isDebug || appn.isTestSuiteRequest) {
                        alert(msg);
                        throw msg;
                    }
                }
                appn.hasFormSubmitAlreadyHappened = true;
                appn.dialog.showLoading();
            }
            if (appn.pageDropUtc) {
                const oldDrop = $('input[name="pageDropUtc"]');
                if (appn.utils.hasValue(oldDrop))
                    oldDrop.remove();
                const pageDropUtcFormParam = $('<input>').attr('type', 'hidden').attr('name', 'pageDropUtc').val(appn.pageDropUtc);
                $(this).closest('form').append($(pageDropUtcFormParam));
            }
        });
        $('.show-loadingScreen-onclick').on('click', function () {
            appn.dialog.showLoading();
        });
        $(window).resize(function () {
            appn.dataTable.redrawOnResize();
            appn.pubSub.publish(appn.pubSub.WINDOW_RESIZED);
        });
        $(document).ajaxError(function (event, jqxhr, settings, thrownError) {
            appn.ui.validateSessionFromAjax(jqxhr);
        });
        $(window).keydown(function (event) {
            if (event.keyCode === 13 && event.target && (event.target.type === 'search' || $(event.target).hasClass('filter'))) {
                event.preventDefault();
                return false;
            }
            return true;
        });
        $('.click-dumb').off().on('click', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
        });
        $('#btn-Checklist').off().on('click', function (e) {
            $('#checklistDialog').modal('show');
        });
        $('#btn-SubmitForReview').click(function () {
            if ($(this).hasClass('hasNoMods')) {
                const $form = $('form#appnForm');
                $form.append('<input type="hidden" name="submitType" value="SubmitForReview" />');
                $form.submit();
            }
            else
                appn.dialog.confirm({
                    modalColor: 'modal-warning',
                    title: T('Submit For Review'),
                    message: `<ul class="pl-10"><li>${T('You will not be able to modify your app(s) branding, name, colors, images etc while in review.')}</li><li>${T('The review process can take up to 2 business days.')}</li><li>${T('We will notify you if there are any issues with the information you have submitted.')}</li></ul><br>${T('If you are satisfied with the information you have submitted, then go ahead and click <b>OK</b>.')}`,
                    className: appn.emptyString,
                    isDeleteAction: true,
                    buttons: {
                        confirm: {
                            label: '<span>' + T('OK') + '</span>',
                            className: 'btn-success'
                        }
                    },
                    callback: function (result) {
                        if (result) {
                            const $form = $('form#appnForm');
                            $form.append('<input type="hidden" name="submitType" value="SubmitForReview" />');
                            $form.submit();
                        }
                    }
                });
        });
        $('.btn-show-password').off().on('click', function (e) {
            e.preventDefault();
            $(this).closest('.form-group').find('input[type="Password"]').prop('type', 'text');
        });
        $('.appn-google-search').off().on('click', function (e) {
            e.preventDefault();
            const baseurl = 'https://www.google.com/search';
            let searchText = $(this).data('searchtext');
            const searchTextId = $(this).data('searchtextid');
            const searchSite = $(this).data('searchsite');
            if (!searchText && !searchTextId)
                return;
            if (searchTextId)
                searchText = $('#' + searchTextId).val();
            if (!searchText) {
                appn.toast.notify(appn.toast.Type.error, T('Search must contain a value.'));
                return;
            }
            let searchUrl = baseurl;
            searchUrl += '?q=' + encodeURIComponent(searchText);
            if (searchSite)
                searchUrl += '&as_sitesearch=' + encodeURIComponent(searchSite);
            window.open(searchUrl, '_blank');
        });
        $('.btnChangeLanguage').off().on('click', function (e) {
            e.preventDefault();
            $('#setLanguageDialog').modal('show');
            $('#setLanguageDialog .btn-success').off().on('click', function (e) {
                appn.dialog.showLoading();
                var selectedLang = $('#setLanguageDialog #langSelect').val();
                appn.ajax.post({
                    url: appn.urls.account.setLanguage,
                    data: { newLang: selectedLang },
                    done: function () {
                        appn.location.reloadCurrentPage();
                    },
                    fail: function () {
                        appn.dialog.hideLoading();
                        appn.dialog.alert({
                            modalColor: 'modal-danger',
                            title: T('Failed to Change Language'),
                            message: T('Please let your administrator know or contact our Support team.'),
                            buttons: {
                                ok: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            autoHeaderIcon: false
                        });
                    }
                });
            });
        });
        $('.btnToggleDarkMode').off().on('click', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var isDark = $btn.find('.fa-moon').hasClass('d-none');
            appn.ajax.post({
                url: appn.urls.account.setDarkMode,
                data: { darkMode: isDark },
                done: function () {
                    appn.location.reloadCurrentPage();
                },
                fail: function () {
                    appn.dialog.hideLoading();
                    appn.dialog.alert({
                        modalColor: 'modal-danger',
                        title: T('Failed to Change Theme'),
                        message: T('Please let your administrator know or contact our Support team.'),
                        buttons: {
                            ok: {
                                label: '<span>' + T('OK') + '</span>',
                                className: 'btn-success'
                            }
                        },
                        autoHeaderIcon: false
                    });
                }
            });
        });
        $('.js-theme-toggle input[type="radio"]').off().on('change', function () {
            var isDark = $(this).val() === 'dark';
            appn.ajax.post({
                url: appn.urls.account.setDarkMode,
                data: { darkMode: isDark },
                done: function () {
                    appn.location.reloadCurrentPage();
                },
                fail: function () {
                    appn.dialog.hideLoading();
                    appn.dialog.alert({
                        modalColor: 'modal-danger',
                        title: T('Failed to Change Theme'),
                        message: T('Please let your administrator know or contact our Support team.'),
                        buttons: {
                            ok: {
                                label: '<span>' + T('OK') + '</span>',
                                className: 'btn-success'
                            }
                        },
                        autoHeaderIcon: false
                    });
                }
            });
        });
        $('.btnClearBrowserCache').off().on('click', function (e) {
            e.preventDefault();
            appn.dialog.confirm({
                modalColor: 'modal-info',
                title: T('Clear Platform Browser Cache'),
                message: T(`The browser cache keeps track of state across the platform. This helps you navigate the site faster but can become bloated from time to time.<br><br>Make sure you have saved your changes for the page you are currently on before you clear this cache.<br><br>Hit <b>OK</b> to reset this cache for a fresh start.<br><span class='small'>Dont worry, this will not affect other websites in your browser.</span>`),
                buttons: {
                    confirm: {
                        label: '<span>' + T('OK') + '</span>',
                        className: 'btn-success'
                    },
                    cancel: {
                        className: 'btn-secondary'
                    }
                },
                lassName: appn.emptyString,
                callback: function (result) {
                    if (result) {
                        appn.localStorage.clearAllAndSetFreshLs();
                        appn.toast.notify(appn.toast.Type.info, T('Platform browser cache successfully cleared!') + '<br>');
                        setTimeout(function () {
                            appn.location.reloadCurrentPage();
                        }, 2000);
                    }
                }
            });
        });
        $('.card-title-text-edit').on('click', function (e) {
            e.stopPropagation();
        });
        $('.card .card-header .card-title').on('click', function () {
            $(this).closest('.card').find('button.card-btn-expand-or-collapse').click();
        });
        $('.card .card-header .card-tools .btn.btn-tool').on('click', function () {
            if ($(this).hasClass('card-btn-expand-or-collapse'))
                return;
            let isCurrentStateExpanded = false;
            const $parentCard = $(this).closest('.card');
            if (!$parentCard.hasClass('collapsed-card'))
                isCurrentStateExpanded = true;
            if (isCurrentStateExpanded)
                return;
            $parentCard.find('button.card-btn-expand-or-collapse').click();
        });
    }
    function addJqueryExtensions() {
        $.validator.addMethod('date', function (value, element) {
            const dtBefore = $(element).attr('dtbefore');
            if (dtBefore) {
                const upperInput = $(`input#${dtBefore}`);
                return appn.utils.isGreaterThanTimeOrDate(upperInput.val(), value);
            }
            const dtAfter = $(element).attr('dtafter');
            if (dtAfter) {
                const lowerInput = $(`input#${dtAfter}`);
                return appn.utils.isGreaterThanTimeOrDate(value, lowerInput.val());
            }
            return true;
        });
        $.fn.dataTableExt.oApi.fnSetFilterKey = function () {
            const that = this;
            this.each(function (i) {
                $.fn.dataTableExt.iApiIndex = i;
                let sPreviousSearch = appn.emptyString;
                const anControl = $('input', that.fnSettings().aanFeatures.f);
                anControl.unbind().bind('keyup', function (e) {
                    if (e.keyCode !== 13)
                        return;
                    if (!sPreviousSearch || sPreviousSearch !== anControl.val()) {
                        sPreviousSearch = anControl.val();
                        $.fn.dataTableExt.iApiIndex = i;
                        that.fnFilter(anControl.val());
                    }
                });
                return that;
            });
            return this;
        };
        $.fn.cascade = function (options) {
            const defaults = {};
            const opts = $.extend(defaults, options);
            return this.each(function () {
                $(this).change(function () {
                    const selectedValue = $(this).val();
                    const params = {};
                    opts.childSelect.append(`<option>${T('Loading...')}</option>`);
                    params[opts.paramName] = selectedValue;
                    appn.ajax.get({
                        url: opts.url,
                        done: function (data) {
                            opts.childSelect.removeAttr('disabled');
                            opts.childSelect.empty();
                            $.each(data, function (index, item) {
                                const option = $('<option/>')
                                    .attr('value', item.Value)
                                    .text(item.Text);
                                if (item.Selected)
                                    option.attr('selected', 'selected');
                                opts.childSelect.append(option);
                            });
                            if (opts.childSelect.hasClass('multiselect'))
                                opts.childSelect.bootstrapDualListbox({
                                    selectedListLabel: T('Selected'),
                                    nonSelectedListLabel: T('Not Selected')
                                });
                        }
                    });
                });
            });
        };
        $.extend({
            getUrlVars: function () {
                const vars = new Array();
                let hash = null;
                const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
                for (let i = 0; i < hashes.length; i++) {
                    hash = hashes[i].split('=');
                    vars.push(hash[0]);
                    vars[hash[0]] = hash[1];
                }
                return vars;
            },
            getUrlVar: function (name) {
                return $.getUrlVars()[name];
            }
        });
    }
})(appn || (appn = {}));
